/**
 * @author: Wangwei
 * @description: 心得管理
 */
import { useRequest, useParams, Helmet } from 'umi';
import styles from '@/pages/camp/css/cmapDetailsCSS.less';
import { useState, useEffect } from 'react';
import cx from 'classnames';
import { Tabs } from 'antd';
import DynamicTabs from '@/pages/camp/components/dynamic/dynamicTabs';
import BannerAdmin from '@/pages/camp/components/BannerAdmin';
import NeedLogin from '@/components/isLogin';
import { getParame } from '@/pages/camp/util/indexUtil';
import { getBaseInfo } from '@/utils/requests/camp/requests_admin';
import { BatchInfoVO } from '@/types/camp/campIndex/indexTypes';
import NoAuth from '@/pages/camp/components/noAuth';
import StudentTable from '@/pages/camp/manage/studentTable';
import StatisticData from '@/pages/camp/manage/statisticData';
export default function CampDetails() {
  const [newTitle, setNewTitle] = useState<string>();
  const { id: batchId } = useParams() as { id: string };
  const [batchInfo, setBatchInfo] = useState<BatchInfoVO>();
  const [auth, setAuth] = useState<boolean>(true);
  // tab路由 & title
  const [tabKey, setTabKey] = useState('');
  const tabParame = getParame('tab');
  const tabEnArr = [['statistics'], ['student'], ['experience']];
  const tabCnArr = [['统计数据'], ['学员管理'], ['心得管理']];
  const getQuery = () => {
    switch (tabParame) {
      case 'statistics':
        setTabKey('1');
        break;
      case 'student':
        setTabKey('2');
        break;
      case 'experience':
        setTabKey('3');
        break;
      default:
        setTabKey('1');
        break;
    }
  };
  useEffect(() => {
    getQuery();
  }, [tabKey]);
  const onTabChanged = (key: any) => {
    setTabKey(key);
    window.history.pushState({}, '', '?tab=' + tabEnArr[key - 1]);
    if (batchInfo) {
      document.title = tabCnArr[key - 1] + batchInfo?.name + batchInfo.camp.name;
    }
  };

  // 获取学习节点基础信息
  const { run: studentBaseInfoRequest } = useRequest(
    () => {
      return getBaseInfo(batchId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setBatchInfo(res);
      },
      onError: (error: any) => {
        const { request, response, data } = error;
        if (response.status === 403) {
          setAuth(false);
        }
      },
    },
  );

  useEffect(() => {
    studentBaseInfoRequest();
  }, []);

  useEffect(() => {
    setNewTitle(batchInfo?.camp.name);
  }, [batchInfo?.camp.name]);

  return (
    <>
      <NeedLogin />
      {!auth && <NoAuth />}
      {newTitle && (
        <Helmet>
          <title>{`心得管理 - ${batchInfo?.name} - ${newTitle}`}</title>
        </Helmet>
      )}
      {batchInfo && (
        <>
          <BannerAdmin setBatchInfo={batchInfo} />

          <div className={cx(styles.camp_details_index_box, 'w1200')}>
            <Tabs
              size="large"
              defaultActiveKey="1"
              activeKey={tabKey}
              destroyInactiveTabPane
              indicator={{ size: (origin) => origin - 26 }}
              onChange={onTabChanged}
              items={[
                {
                  label: '统计数据',
                  key: '1',
                  children: <StatisticData batchInfo={batchInfo} />,
                },
                {
                  label: '学员管理',
                  key: '2',
                  children: <StudentTable batchInfo={batchInfo} />,
                },
                {
                  label: '心得管理',
                  key: '3',
                  children: (
                    <DynamicTabs campId={batchInfo?.camp.id} batchId={batchInfo.id} hide={true} />
                  ),
                },
              ]}
            />
          </div>
        </>
      )}
    </>
  );
}
